import styled from "styled-components";

export const Wrapper = styled.div`
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 8px;
    margin: 16px 16px;
    width: 350px;
    height: 150px;
   align-content: center;

    // Media Queries
    @media (max-width: 830px){ width: 250px; }
    @media (max-width: 630px){
        width: 180px;
        h2{font-size:14px}
        a{font-size:14px}
        word-wrap: break-word;
    }
    @media (max-width: 490px){ width: 140px; }
    @media (max-width: 410px){ width: 100px; height:200px; h2{font-size:12px} a{font-size:12px}}
`

export const WrapperTitle = styled.h2`
    font-size: 18px;
    font-weight: bold;
    margin: 8px 0;

`;

export const WrapperFullName = styled.h2`
    font-size: 16px;
    font-weight: bold;
    margin: 8px 0;
    color: #2d3748;

`;

export const WrapperLink = styled.a`
    font-size: 16px;
    font-weight: bold;
    margin: 8px 0;
    color: #3182ce;

`;